import type { UserAccessGroup } from "types/user";

export const isSelectUser = (accessGroup: UserAccessGroup) =>
  accessGroup === "select" || accessGroup === "select-v2";

export const isConsumer = (accessGroup: UserAccessGroup) =>
  accessGroup === "consumer" || isSelectUser(accessGroup);

export const isFreeUser = (accessGroup: UserAccessGroup) =>
  accessGroup === "free";

export const isPublicUser = (accessGroup: UserAccessGroup) =>
  accessGroup === "public";

export const isAcademicUser = (accessGroup: UserAccessGroup) =>
  accessGroup === "academic";

export const isAcademicDirectUser = (accessGroup: UserAccessGroup) =>
  accessGroup === "academic-direct";
